export class MedicineSpecificationContentModel {
    public medicineSpecificationId: number;
    public langId: number;
    public description: string;
    public pharmaceuticalForm: string;
    public color: string;
    public shape: string;
    public packaging: string;
    public packageSize: string;
    public ddd: string;
    public score: string;
    public flavour: string;
    public containsDesc: string;
}